/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetTriggerEventForms200Response } from '../models';
/**
 * TriggerEventFormApi - axios parameter creator
 * @export
 */
export const TriggerEventFormApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * トリガーイベントフォーム属性一覧取得API
         * @summary トリガーイベントフォーム属性一覧取得API
         * @param {string} eventType イベントタイプ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTriggerEventForms: async (eventType: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventType' is not null or undefined
            assertParamExists('getTriggerEventForms', 'eventType', eventType)
            const localVarPath = `/api/user/trigger_event_forms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (eventType !== undefined) {
                localVarQueryParameter['eventType'] = eventType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TriggerEventFormApi - functional programming interface
 * @export
 */
export const TriggerEventFormApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TriggerEventFormApiAxiosParamCreator(configuration)
    return {
        /**
         * トリガーイベントフォーム属性一覧取得API
         * @summary トリガーイベントフォーム属性一覧取得API
         * @param {string} eventType イベントタイプ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTriggerEventForms(eventType: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTriggerEventForms200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTriggerEventForms(eventType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TriggerEventFormApi - factory interface
 * @export
 */
export const TriggerEventFormApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TriggerEventFormApiFp(configuration)
    return {
        /**
         * トリガーイベントフォーム属性一覧取得API
         * @summary トリガーイベントフォーム属性一覧取得API
         * @param {string} eventType イベントタイプ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTriggerEventForms(eventType: string, options?: any): AxiosPromise<GetTriggerEventForms200Response> {
            return localVarFp.getTriggerEventForms(eventType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TriggerEventFormApi - interface
 * @export
 * @interface TriggerEventFormApi
 */
export interface TriggerEventFormApiInterface {
    /**
     * トリガーイベントフォーム属性一覧取得API
     * @summary トリガーイベントフォーム属性一覧取得API
     * @param {string} eventType イベントタイプ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TriggerEventFormApiInterface
     */
    getTriggerEventForms(eventType: string, options?: AxiosRequestConfig): AxiosPromise<GetTriggerEventForms200Response>;

}

/**
 * Request parameters for getTriggerEventForms operation in TriggerEventFormApi.
 * @export
 * @interface TriggerEventFormApiGetTriggerEventFormsRequest
 */
export interface TriggerEventFormApiGetTriggerEventFormsRequest {
    /**
     * イベントタイプ
     * @type {string}
     * @memberof TriggerEventFormApiGetTriggerEventForms
     */
    readonly eventType: string
}

/**
 * TriggerEventFormApi - object-oriented interface
 * @export
 * @class TriggerEventFormApi
 * @extends {BaseAPI}
 */
export class TriggerEventFormApi extends BaseAPI implements TriggerEventFormApiInterface {
    /**
     * トリガーイベントフォーム属性一覧取得API
     * @summary トリガーイベントフォーム属性一覧取得API
     * @param {TriggerEventFormApiGetTriggerEventFormsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TriggerEventFormApi
     */
    public getTriggerEventForms(requestParameters: TriggerEventFormApiGetTriggerEventFormsRequest, options?: AxiosRequestConfig) {
        return TriggerEventFormApiFp(this.configuration).getTriggerEventForms(requestParameters.eventType, options).then((request) => request(this.axios, this.basePath));
    }
}
